import React, { useState, useEffect } from 'react';

const OfferCountdown = ({ targetDate }) => {
  const calculateTimeLeft = () => {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    // Clear interval on component unmount
    return () => clearInterval(timer);
  }, [targetDate]);

  const hasTimeLeft = Object.keys(timeLeft).length > 0;

  if (!hasTimeLeft) {
    // return <span className="text-red-500 font-bold">Offer Expired!</span>;
    return <span className="text-red-500 font-bold"></span>;
  }

  return (
    <div className="flex gap-2 text-lg font-semibold">
      {timeLeft.days > 0 && <span>{timeLeft.days}d :</span>}
      <span>{String(timeLeft.hours).padStart(2, '0')}h :</span>
      <span>{String(timeLeft.minutes).padStart(2, '0')}m :</span>
      <span>{String(timeLeft.seconds).padStart(2, '0')}s</span>
    </div>
  );
};

export default OfferCountdown;